module.exports = __webpack_public_path__ + "img/bag.3735327f.png";